export enum AccessTokenServiceNames {
    CCF_BASIC = 'cfc',
    CCF_ENTERPRISE = 'cfc.ccf-enterprise',
    CCF_ASSESSMENT = 'cfc.ccf-assessment',
    CCF_EMPLOYEE_COMMUTING = 'cfc.ccf-employee-commuting-survey',
}
